<h2 *ngIf="loading" class="loading-message">Loading Recaps...</h2>

<h2 *ngIf="err" class="error-message">{{err}}</h2>

<div *ngIf="!loading" class="routed-container">
  <div class="routed-content">
  	<h1 class="title-message">Your Recaps</h1>
    <p class="game-list-header">Outstanding Recaps</p>
    <app-game-stub *ngFor="let g of pastGames" [game]="g"></app-game-stub>
    <p class="game-list-header">Completed Recaps</p>
  	<app-game-stub *ngFor="let p of approvedGames" [game]="p"></app-game-stub>
    <div class="hrz-center std-py w-100">
      <button *ngIf="!endOfPage" class="basic-btn-grey " (click)="getMoreGames()" [disabled]="fetchingMore">
        {{ fetchingMore ? 'Retrieving...':'Show More' }}
      </button>
      <p *ngIf="endOfPage">You're all caught up!</p>
    </div>
  </div>
</div>
